'use client';

import { Building2, Briefcase, Users, X } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ResultFilter } from '../types';

const FILTERS: { key: Exclude<ResultFilter, 'all'>; label: string; icon: React.ComponentType<{ className?: string }> }[] = [
  { key: 'companies', label: 'Companies', icon: Building2 },
  { key: 'jobs', label: 'Jobs', icon: Briefcase },
  { key: 'contacts', label: 'Contacts', icon: Users },
];

interface EntityFilterBarProps {
  value: ResultFilter;
  onChange: (filter: ResultFilter) => void;
  className?: string;
}

export function EntityFilterBar({ value, onChange, className }: EntityFilterBarProps) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      {value !== 'all' && (
        <button
          type="button"
          onClick={() => onChange('all')}
          className="inline-flex h-7 w-7 items-center justify-center rounded-full border border-border/75 bg-muted/25 text-muted-foreground transition-colors hover:bg-muted/50"
          aria-label="Clear filter"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      )}
      {FILTERS.map(({ key, label, icon: Icon }) => {
        const isActive = value === key;
        return (
          <button
            key={key}
            type="button"
            onClick={() => onChange(isActive ? 'all' : key)}
            className={cn(
              'inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors',
              isActive
                ? 'border border-primary/35 bg-primary/10 text-primary'
                : 'border border-border/75 bg-muted/25 text-muted-foreground hover:bg-muted/50',
            )}
          >
            <Icon className="h-3.5 w-3.5" />
            {label}
          </button>
        );
      })}
    </div>
  );
}
